import downloadImageByUrl from '@modules/core/utils/downloadImageByUrl';
import { useToastStore } from '@modules/toast/store';

export interface DownloadImageByUrlComposable {
  downloadImage(imageUrl?: string, imageName?: string): Promise<void>;
}

export default function useDownloadImageByUrl(): DownloadImageByUrlComposable {
  const { displayPresetToast } = useToastStore();

  async function downloadImage(imageUrl?: string, imageName?: string): Promise<void> {
    if (imageUrl) {
      try {
        await downloadImageByUrl(imageUrl, imageName || Math.random().toString().substring(2));
      } catch (error) {
        displayPresetToast('error', 'Failed to load image');
        throw error;
      }
    } else {
      displayPresetToast('error', 'No image URL to download');
      throw new Error('No image URL to download');
    }
  }

  return {
    downloadImage,
  };
}
